import { ComposeViewState } from 'owa-mail-compose-store';
import { IAttachmentLocalComputerFilePicker } from 'owa-attachment-filepicker';
import trySaveMessage from 'owa-mail-compose-actions/lib/actions/trySaveMessage';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import AttachmentMenuEntrySource from '../types/AttachmentMenuEntrySource';
import clickAttachButton from 'owa-mail-compose-actions/lib/actions/clickAttachButton';
import { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { aFPCreateAttachmentHandler } from '../utils/createAttachmentHandler';
import { lazyInsertLinks } from 'owa-insert-link';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';

export function openLocalFilePicker(
    viewState: ComposeViewState,
    filePickerToOpen: () => IAttachmentLocalComputerFilePicker | null,
    datapointName: string
) {
    if (!viewState.itemId) {
        trySaveMessage(viewState);
    }
    const filePickerComp = filePickerToOpen();

    const datapoint = new PerformanceDatapoint(datapointName);
    datapoint.addCustomData([AttachmentMenuEntrySource.ToolBar]);

    if (filePickerComp) {
        filePickerComp.click();
        datapoint.end();
    } else {
        datapoint.endWithError(DatapointStatus.ClientError, new Error('Lazy component not loaded'));
    }
}

export function openCloudFilePicker(viewState: ComposeViewState, targetWindow?: Window) {
    clickAttachButton(
        false /*isInline*/,
        params => {
            const baseProperties = { isInline: params.isInline, isHiddenInline: false };
            const properties: CreateAttachmentsProperties = params.shouldShare
                ? { ...baseProperties, shouldShare: true }
                : { ...baseProperties, shouldShare: false };

            aFPCreateAttachmentHandler(
                params.files,
                viewState,
                properties,
                params.dataProviderType
            );
        },
        async params => {
            const insertLinks = await lazyInsertLinks.import();
            insertLinks(
                params.files,
                viewState,
                viewState,
                getCurrentFromAddress(viewState.toRecipientWell),
                targetWindow
            );
        },
        viewState,
        targetWindow
    );
}
